import { Credential } from 'types/Credentials';
export enum FormatType {
    Script,
    String,
    Object,
}

function formatCredentials(
    script: string,
    formatType: FormatType,
): string | Credential[] {
    try {
        const obj = JSON.parse(script);
        const formattedArray = Object.entries<string>(obj).map(
            ([key, value]) => {
                let formattedKey = key;
                switch (key) {
                    case 'AccessKey':
                        formattedKey = 'aws_access_key_id';
                        break;
                    case 'SessionKey':
                        formattedKey = 'aws_secret_access_key';
                        break;
                    case 'sessionToken':
                        formattedKey = 'aws_session_token';
                        break;
                    case 'SessionToken':
                        formattedKey = 'aws_session_token';
                        break;
                    default:
                        break;
                }
                switch (formatType) {
                    case FormatType.Script:
                        return `export ${formattedKey.toUpperCase()}="${value}"`;
                    case FormatType.String:
                        return `${formattedKey.toLowerCase()}=${value}`;
                    case FormatType.Object:
                        return { key: formattedKey, value };
                    default:
                        return '';
                }
            },
        );
        if (formatType === FormatType.Object) {
            return formattedArray as Credential[];
        }
        return formattedArray.join('\n');
    } catch (error) {
        console.error('Error parsing JSON string:', error);
        if (formatType === FormatType.Object) {
            return [];
        }
        return '';
    }
}
export default formatCredentials;
